const getters = {
  getActiveMenu: state => state.activeMenu,
  getNebPay: state => state.nebPay,
  getAccounts: state => state.accounts,
  getAccountsError: state => state.accountsError,
  getUser: state => state.user,
  getNeedSingUp: state => state.needSingUp,
  getDappAddress: state => state.dappAddress
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js